var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.513 10.354a21.563 21.563 0 0 1 2.577 4.275L23.505 29.067l-8.185-5.131v-6.173l8.185 5.13 17.008-12.539Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.967 23.5c0-.277.007-.552.02-.826l-4.96-.243a21.442 21.442 0 0 0 6.27 16.27l3.519-3.517A16.476 16.476 0 0 1 6.967 23.5Z",
    fill: "url(#33_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.966c.278 0 .553.01.826.024l.248-4.963a22.632 22.632 0 0 0-1.073-.025A21.44 21.44 0 0 0 8.297 8.298l3.519 3.519A16.475 16.475 0 0 1 23.5 6.966Z",
    fill: "url(#33_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 40.034c-.276 0-.551 0-.826-.022l-.249 4.96a21.428 21.428 0 0 0 16.27-6.27l-3.511-3.517a16.484 16.484 0 0 1-11.683 4.85Z",
    fill: "url(#33_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.82 9.851 37 6.77A21.402 21.402 0 0 0 23.495 2v4.966A16.45 16.45 0 0 1 32.82 9.85Z",
    fill: "url(#33_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.5a21.63 21.63 0 0 0-.338-3.853l-4.627 3.41v.443a16.49 16.49 0 0 1-5.447 12.254l3.338 3.69A21.445 21.445 0 0 0 45 23.5Z",
    fill: "#21A038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 40.034a16.498 16.498 0 0 1-12.255-5.446l-3.687 3.336A21.443 21.443 0 0 0 23.501 45v-4.966Z",
    fill: "url(#33_svg__e)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.414 11.246-3.337-3.69A21.443 21.443 0 0 0 2 23.5h4.967a16.493 16.493 0 0 1 5.447-12.254Z",
    fill: "url(#33_svg__f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__a",
    x1: 9.302,
    y1: 38.081,
    x2: 3.875,
    y2: 22.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__b",
    x1: 9.716,
    y1: 9.176,
    x2: 23.693,
    y2: 3.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__c",
    x1: 22.098,
    y1: 42.003,
    x2: 37.904,
    y2: 38.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__d",
    x1: 22.461,
    y1: 3.663,
    x2: 35.974,
    y2: 7.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__e",
    x1: 8.804,
    y1: 37.319,
    x2: 23.513,
    y2: 42.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "33_svg__f",
    x1: 3.85,
    y1: 24.101,
    x2: 9.755,
    y2: 8.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.d36f254960a5b658c02827c4c1412b61.svg";
export { ForwardRef as ReactComponent };